//* Adrop 광고 유닛 ID
//* 콘솔 유닛명은 WEL_{디바이스}_{화면}_{위치} 형식을 쓰고, Backfill 비활성 유닛은 끝에 -백필-OFF를 붙인다.
//* 위치별 매핑은 docs/plans/2026-05-26-001-feat-adrop-ads-expansion-plan.md 참조
//* dev 환경에선 Adrop이 광고를 내려주지 않으므로 prod/dev 분기 없이 단일 상수로 사용한다.
//* 빈 string('') 키는 콘솔 ID 미발급 placeholder — useAd 호출처에서 falsy 가드로 null 반환.

import { IS_PRODUCT } from './env';

//* 운영 도메인이 아닌 모든 환경(로컬 + dev 배포)에서 광고 위치 확인용 placeholder 노출.
//* 운영 외 환경에선 Adrop이 광고를 안 내려주므로 useAd가 SDK 로드를 건너뛰고,
//* 각 슬롯은 "개발용 광고 영역" placeholder로 통일 노출한다.
export const AD_SLOT_DEBUG_PLACEHOLDER_ENABLED = !IS_PRODUCT;

export const AD_UNIT_IDS = {
  //* === 글로벌 공용 PC 우측 사이드 ===
  GLOBAL_SIDE_P: '01KTX7JDF9G12DFAD6EZCKHRCH', //* WEL_PC_공통_우측

  //* === 홈 (allowed)/(home) ===
  HOME_FEED_NATIVE_M: '01KTXH3ZPW81K5P5W7X1QHVNBS', //* WEL_MO_홈_목록중간_카드-백필-OFF
  HOME_FEED_NATIVE_P: '01KTXH2P2V9SR9092GQA4XQ3HY', //* WEL_PC_홈_목록중간_카드-백필-OFF
  HOME_FEED_LIST_BANNER_M: '01KRJ2719RF34VX0Z4N2SCK764', //* WEL_MO_홈_목록중간_띠배너
  HOME_FEED_LIST_BANNER_P: '01KTX7MFVSTRMC4CPX66TXR02G', //* WEL_PC_홈_목록중간_띠배너

  //* === 통합검색 + 카테고리별 검색 (allowed)/search ===
  SEARCH_TOP_M: '01KTXGRA7XNN5X29W8BV5ARN96', //* WEL_MO_통합검색_상단
  SEARCH_TOP_P: '01KRJ2719SRQAYF4HTVZWCYM2S', //* WEL_PC_통합검색_상단
  SEARCH_SIDE_P: '01KTXGV8JV68D37N848BQZTSNB', //* WEL_PC_통합검색_우측

  //* 통합검색 전체 탭 — 카테고리별 결과 슬롯
  SEARCH_ALL_POLICY_M: '01KTXFX9YEDAES9V0MZMZZWKQT', //* WEL_MO_통합검색_정책결과_목록중간
  SEARCH_ALL_POLICY_P: '01KTXFYCT29RTE57SWQ6XXVDWE', //* WEL_PC_통합검색_정책결과_목록중간
  SEARCH_ALL_HOMETOWNS_M: '01KTXFZMN4KWDHF7C21TGXC2SP', //* WEL_MO_통합검색_동네소식결과_목록중간
  SEARCH_ALL_HOMETOWNS_P: '01KTXG0TB7B9X119VC33773FNX', //* WEL_PC_통합검색_동네소식결과_목록중간
  SEARCH_ALL_POLICY_GUIDE_M: '01KTXG2H1FKWMRE2VWASRWQ1QX', //* WEL_MO_통합검색_정책활용가이드결과_목록중간
  SEARCH_ALL_POLICY_GUIDE_P: '01KTXG3P673GYVQX4KZ9E924BQ', //* WEL_PC_통합검색_정책활용가이드결과_목록중간

  //* 통합검색 전체 탭 — 콘솔 ID 미발급 (placeholder)
  SEARCH_ALL_FESTIVAL_M: '',
  SEARCH_ALL_FESTIVAL_P: '',
  SEARCH_ALL_DONATION_BUSINESS_M: '',
  SEARCH_ALL_DONATION_BUSINESS_P: '',

  //* 단일 카테고리 검색 결과
  SEARCH_POLICY_M: '01KTXG58NGGFCCCMH5QJKKZHQZ', //* WEL_MO_정책검색결과_목록중간
  SEARCH_POLICY_P: '01KTXG6APBSWP8JEH0QVQCP6R0', //* WEL_PC_정책검색결과_목록중간
  SEARCH_HOMETOWNS_M: '01KTXG7H3GA1RSXQX5YHTESHG1', //* WEL_MO_동네소식검색결과_목록중간
  SEARCH_HOMETOWNS_P: '01KTXG91XG9J79C1BT9APSDH1R', //* WEL_PC_동네소식검색결과_목록중간
  SEARCH_POLICY_GUIDE_M: '01KTXGADP04X8QJA6JBH6PDTP6', //* WEL_MO_정책활용가이드검색결과_목록중간
  SEARCH_POLICY_GUIDE_P: '01KTXGB4WM4B1AFEY6QTHD36HX', //* WEL_PC_정책활용가이드검색결과_목록중간
  SEARCH_GIFT_M: '01KTXGD3W1Q1MYTH9VF0WNGZB0', //* WEL_MO_답례품검색결과_목록중간-백필-OFF
  SEARCH_GIFT_P: '01KTXGDXCNGN5W21RNYHQ521A7', //* WEL_PC_답례품검색결과_목록중간-백필-OFF
  SEARCH_DONATION_BUSINESS_M: '01KTXGFBV49YM9Q91488K0NRAM', //* WEL_MO_지정기부사업검색결과_목록중간
  SEARCH_DONATION_BUSINESS_P: '01KTXGG4A03BZ8R4GCX46EFRR2', //* WEL_PC_지정기부사업검색결과_목록중간
  SEARCH_LOCAL_MARKET_M: '01KTXGHQK5YCYKTQFB3TH4PVKV', //* WEL_MO_웰마켙검색결과_목록중간-백필-OFF
  SEARCH_LOCAL_MARKET_P: '01KTXGJQT55A3K9H7AS6TTY6N3', //* WEL_PC_웰마켙검색결과_목록중간-백필-OFF

  //* 축제 카테고리 — 콘솔 ID 미발급 (placeholder)
  SEARCH_FESTIVAL_M: '',
  SEARCH_FESTIVAL_P: '',

  //* === 정책활용가이드 상세 (allowed)/community/policyInfo/[id] ===
  POLICY_GUIDE_TOP_M: '01KTXGWP0AE7EQ5Q0Z0AKV7J93', //* WEL_MO_정책활용가이드상세_상단
  POLICY_GUIDE_SIDE_P: '01KTXGXK5A37PMMVGHCKFF4MH8', //* WEL_PC_정책활용가이드상세_우측
  POLICY_GUIDE_BOTTOM_M: '01KTXGYF6WVNGAV6PP38YF0K97', //* WEL_MO_정책활용가이드상세_하단
  POLICY_GUIDE_BOTTOM_P: '01KTXH0CHA4RQA3XE37F4C85DN', //* WEL_PC_정책활용가이드상세_하단

  //* === 마이페이지 — 콘솔 ID 미발급 (placeholder) ===
  MYPAGE_BOTTOM_M: '',
  MYPAGE_BOTTOM_P: '',
  MYPAGE_SIDE_P: '',

  //* === 웰로 키워드 펼침 패널 (전 화면 공통) ===
  TREND_KEYWORD_RANK5_M: '01M1DW49ET16FJG31YHBYW9NVG', //* WEL_MO_웰로키워드_5위하단
  TREND_KEYWORD_RANK5_P: '01M1DW5AS9G7EZVPDD6XZS7X2G', //* WEL_PC_웰로키워드_5위하단
  TREND_KEYWORD_RANK10_M: '01M1DW5YY462EMD70Z8PD0Z268', //* WEL_MO_웰로키워드_10위하단
  TREND_KEYWORD_RANK10_P: '01M1DW6JZ0XFZF4B25CDXMHST3', //* WEL_PC_웰로키워드_10위하단

  //* === 혜택 (allowed)/benefit ===
  BENEFIT_HOME_TOP_NATIVE_M: '01KZDWRK689FY4JS8BBG6FMK2P', //* WEL_MO_혜택메인_상단
  BENEFIT_HOME_MIDDLE_NATIVE_M: '01KZDWXB60CYSF8V5R4C15KRDZ', //* WEL_MO_혜택메인_중간
  BENEFIT_HOME_MIDDLE_NATIVE_P: '01KZDWY84B2YQ6ZQRT7MQJ31W0', //* WEL_PC_혜택메인_중간
} as const;
